import React, { useEffect } from 'react'
import { useNavigate } from '../../../hooks'
import FnaHeader from './FnaHeader'
import LcrHeader from './LcrHeader'

/**
 * @describe - This component determines which header to display based on the page/step/demoy/etc.
 */
export default function Header({ hideFSHF, setHideFSHF }) {
  const { location } = useNavigate()
  const hidePageHeader = location.pathname.includes('/pdf') || location.pathname === '/choose-your-demo'
  const hideCustomHeader = !hideFSHF || hidePageHeader
  const showLcrHeader = location.pathname.includes('/lcr-demo')

  useEffect(() => {
    if (location.pathname === '/choose-your-demo') {
      setHideFSHF(false)
    } else {
      setHideFSHF(
        hidePageHeader ||
          showLcrHeader ||
          location.search.includes('memberUuid=') ||
          location.search.includes('tryDemo=') ||
          (location.pathname.includes('/verify-account') && !location.search.includes('returnUrl='))
      )
    }
  }, [hidePageHeader, location.search, location.pathname, setHideFSHF, showLcrHeader])

  if (showLcrHeader) return <LcrHeader />
  if (hideCustomHeader) return null
  return <FnaHeader />
}
